// framework
import { immerable, produce } from "immer";
// api
import * as Client from "../../../../api/Client";
import { CallResultError } from "../../../../api/callHelper";

export interface IFilterViewModel {
    readonly applicationTrackingType: Client.OpggsApplicationTrackingTypeEnum | undefined;
    readonly isCompleted: boolean;
}

export interface IRootViewModel {
    readonly applicationTrackingType: Client.OpggsApplicationTrackingTypeEnum | undefined;
    readonly isCompleted: boolean;
    readonly isBusy: boolean;
    readonly error: CallResultError | undefined;
    readonly applicationTrackingTypes: Client.GetPublicApplicationsTrackingTrackingTypeDto[];
    readonly applicationTrackingTypeSummary: Client.GetPublicApplicationsTrackingTrackingTypeSummaryItemDto[];
    readonly applicationTrackingStatusSummary: Client.GetPublicApplicationsTrackingTrackingStatusSummaryItemDto[];
    readonly applicationList: Client.GetPublicApplicationsTrackingApplicationListItemDto[];

    applicationTrackingLoading(filter: IFilterViewModel): IRootViewModel;
    applicationTrackingLoaded(response: Client.GetPublicOpggsApplicationsTrackingResponseDto | undefined, error: CallResultError | undefined): IRootViewModel;
}

export class RootViewModel implements IRootViewModel {
    [immerable] = true;

    constructor() {
        this.applicationTrackingType = undefined;
        this.isCompleted = false;
        this.isBusy = false;
        this.error = undefined;
        this.applicationTrackingTypes = [];
        this.applicationTrackingTypeSummary = [];
        this.applicationTrackingStatusSummary = [];
        this.applicationList = [];
    }
    public readonly applicationTrackingType: Client.OpggsApplicationTrackingTypeEnum | undefined;
    public readonly isCompleted: boolean;
    public readonly isBusy: boolean;
    public readonly error: CallResultError | undefined;
    public readonly applicationTrackingTypes: Client.GetPublicApplicationsTrackingTrackingTypeDto[];
    public readonly applicationTrackingTypeSummary: Client.GetPublicApplicationsTrackingTrackingTypeSummaryItemDto[];
    public readonly applicationTrackingStatusSummary: Client.GetPublicApplicationsTrackingTrackingStatusSummaryItemDto[];
    public readonly applicationList: Client.GetPublicApplicationsTrackingApplicationListItemDto[];

    public applicationTrackingLoading(filter: IFilterViewModel): IRootViewModel {
        return produce(this, (draft) => {
            draft.isBusy = true;

            draft.applicationTrackingType = filter.applicationTrackingType;
            draft.isCompleted = filter.isCompleted;
            // current results are no longer valid
            draft.applicationTrackingTypes = [];
            draft.applicationTrackingTypeSummary = [];
            draft.applicationTrackingStatusSummary = [];
            draft.applicationList = [];
        });
    }

    public applicationTrackingLoaded(response: Client.GetPublicOpggsApplicationsTrackingResponseDto | undefined, error: CallResultError | undefined): IRootViewModel {
        return produce(this, (draft) => {
            draft.applicationTrackingTypes = response?.applicationTrackingTypes ?? [];
            draft.applicationTrackingTypeSummary = response?.applicationTrackingTypeSummary ?? [];
            draft.applicationTrackingStatusSummary = response?.applicationTrackingStatusSummary ?? [];
            draft.applicationList = response?.applicationList ?? [];

            draft.isBusy = false;
            draft.error = error;
        });
    }
}
